import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ImoveisPage = lazy(() => import('../pages/imoveis/page'));
const ImovelDetalhePage = lazy(() => import('../pages/imovel-detalhe/page'));
const ImoveisCidadePage = lazy(() => import('../pages/imoveis-cidade/page'));
const ComprarImovelSergipePage = lazy(() => import('../pages/comprar-imovel-sergipe/page'));
const VenderImovelSergipePage = lazy(() => import('../pages/vender-imovel-sergipe/page'));
const SobrePage = lazy(() => import('../pages/sobre/page'));
const ContatoPage = lazy(() => import('../pages/contato/page'));
const VideosPage = lazy(() => import('../pages/videos/page'));
const AvaliarImovelPage = lazy(() => import('../pages/avaliar-imovel/page'));
const FavoritosPage = lazy(() => import('../pages/favoritos/page'));
const CompararImoveisPage = lazy(() => import('../pages/comparar-imoveis/page'));
const ToursVirtuaisPage = lazy(() => import('../pages/tours-virtuais/page'));
const AdminLoginPage = lazy(() => import('../pages/admin/login/page'));
const AdminDashboardPage = lazy(() => import('../pages/admin/dashboard/page'));
const AdminImoveisPage = lazy(() => import('../pages/admin/imoveis/page'));
const AdminLeadsPage = lazy(() => import('../pages/admin/leads/page'));
const AdminLeadDetalhes = lazy(() => import('../pages/admin/leads/detalhes/page'));
const AdminClientesPage = lazy(() => import('../pages/admin/clientes/page'));
const AdminFunilPage = lazy(() => import('../pages/admin/funil/page'));
const AdminAgendaPage = lazy(() => import('../pages/admin/agenda/page'));
const AdminVideosPage = lazy(() => import('../pages/admin/videos/page'));
const AdminPropostasPage = lazy(() => import('../pages/admin/propostas/page'));
const AdminRelatoriosPage = lazy(() => import('../pages/admin/relatorios/page'));
const AdminRelatorioMensalPage = lazy(() => import('../pages/admin/relatorios/mensal/page'));
const AdminVendasPage = lazy(() => import('../pages/admin/vendas/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/imoveis',
    element: <ImoveisPage />,
  },
  {
    path: '/imoveis/:cidade',
    element: <ImoveisCidadePage />,
  },
  {
    path: '/imovel/:slug',
    element: <ImovelDetalhePage />,
  },
  {
    path: '/favoritos',
    element: <FavoritosPage />,
  },
  {
    path: '/comparar-imoveis',
    element: <CompararImoveisPage />,
  },
  {
    path: '/sobre',
    element: <SobrePage />,
  },
  {
    path: '/contato',
    element: <ContatoPage />,
  },
  {
    path: '/avaliar-imovel',
    element: <AvaliarImovelPage />,
  },
  {
    path: '/comprar-imovel-sergipe',
    element: <ComprarImovelSergipePage />,
  },
  {
    path: '/vender-imovel-sergipe',
    element: <VenderImovelSergipePage />,
  },
  {
    path: '/videos',
    element: <VideosPage />,
  },
  {
    path: '/tours-virtuais',
    element: <ToursVirtuaisPage />,
  },
  {
    path: '/admin/login',
    element: <AdminLoginPage />,
  },
  {
    path: '/admin/dashboard',
    element: <AdminDashboardPage />,
  },
  {
    path: '/admin/imoveis',
    element: <AdminImoveisPage />,
  },
  {
    path: '/admin/leads',
    element: <AdminLeadsPage />,
  },
  {
    path: '/admin/leads/:id',
    element: <AdminLeadDetalhes />,
  },
  {
    path: '/admin/clientes',
    element: <AdminClientesPage />,
  },
  {
    path: '/admin/funil',
    element: <AdminFunilPage />,
  },
  {
    path: '/admin/agenda',
    element: <AdminAgendaPage />,
  },
  {
    path: '/admin/videos',
    element: <AdminVideosPage />,
  },
  {
    path: '/admin/propostas',
    element: <AdminPropostasPage />
  },
  {
    path: '/admin/vendas',
    element: <AdminVendasPage />
  },
  {
    path: '/admin/relatorios',
    element: <AdminRelatoriosPage />
  },
  {
    path: '/admin/relatorios/mensal',
    element: <AdminRelatorioMensalPage />
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
